<soft-page>
  <soft-page-header [customClass]="'!p-0'">
    <div class="w-full mb-4">
      <soft-default-header
        [title]="steps[1].header | translate"
        [subtitle]="steps[1].subHeader | translate"
      />
      <soft-ds-progress-steps class="mx-2" [steps]="steps" [currentIndex]="1" />
    </div>
  </soft-page-header>

  <soft-page-panel panelStyle="plain" clip class="overflow-hidden">
    <soft-page-panel-header>
      <soft-ds-search-input class="pt-2 mt-1" size="lg" placeholder="Artikel suchen..." (valueChange)="searchValue$.next($event)"></soft-ds-search-input>
    </soft-page-panel-header>

    @if (quellLagerplatz$ | async; as quellLagerplatz) {
      <ng-container>
        <soft-scan-button class="mt-4" />

        @if (quellLagerplatz.inhalt?.length) {
          <div class="soft-overline mt-4">
            {{ '#LAGERPLATZ_UMLAGERUNG.PAGES.ARTIKEL_AUSWAHL.ARTIKEL' | translate }}
          </div>
          <soft-artikel-menge-auswahl
            [lagerplatzInhalt]="filteredStorageLocationData()"
            (artikelMengeChange)="onSelect($event)"
          />
        }

        @if (quellLagerplatz.mischpaletten?.length) {
          <div class="soft-overline mt-4">
            {{ '#LAGERPLATZ_UMLAGERUNG.PAGES.ARTIKEL_AUSWAHL.MISCHPALETTEN' | translate }}
          </div>
          <div class="flex flex-col gap-2">
            @for (
              mixedPallet of quellLagerplatz.mischpaletten;
              track mixedPallet.palette?.sscc
              ) {
              <div
                class="flex flex-row gap-2 soft-card hover:bg-hover cursor-pointer"
                (click)="onSelectMischpalette(mixedPallet)"
              >
                <soft-mixed-pallet
                  class="w-full"
                  [pallet]="mixedPallet.palette"
                  [stockyard]="mixedPallet.lagerplatz"
                  [items]="mixedPallet.artikel"
                />
                <div class="flex flex-col justify-center items-center">
                  <i class="fa-regular fa-chevron-right color-light"></i>
                </div>
              </div>
            }
          </div>
        }
      </ng-container>
    }
  </soft-page-panel>

  @if (loading$ | async) {
    <soft-blocking-loading-spinner class="top-0 right-0" />
  }
</soft-page>
